export function initNavbar(): void {
  const navbar = document.getElementById('navbar')
  const mobileMenuBtn = document.getElementById('mobile-menu-btn')
  const mobileMenu = document.getElementById('mobile-menu')

  if (!navbar) return

  // Handle scroll - add background when scrolled
  const handleScroll = (): void => {
    const currentScrollY = window.scrollY

    if (currentScrollY > 50) {
      navbar.classList.add('bg-charcoal/95')
      navbar.classList.remove('bg-charcoal/80')
    } else {
      navbar.classList.add('bg-charcoal/80')
      navbar.classList.remove('bg-charcoal/95')
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true })

  // Mobile menu toggle
  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', () => {
      const isHidden = mobileMenu.classList.contains('hidden')

      if (isHidden) {
        mobileMenu.classList.remove('hidden')
        mobileMenuBtn.setAttribute('aria-expanded', 'true')
      } else {
        mobileMenu.classList.add('hidden')
        mobileMenuBtn.setAttribute('aria-expanded', 'false')
      }
    })

    // Close mobile menu when clicking a link
    const mobileLinks = mobileMenu.querySelectorAll('a')
    mobileLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.add('hidden')
        mobileMenuBtn.setAttribute('aria-expanded', 'false')
      })
    })
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href')
      if (!href || href === '#') return

      const target = document.querySelector(href)
      if (target) {
        e.preventDefault()
        const navbarHeight = navbar.offsetHeight
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - navbarHeight

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        })
      }
    })
  })
}
